import { render, staticRenderFns } from "./TodoTaskModal.vue?vue&type=template&id=d88dea1c&"
import script from "./TodoTaskModal.vue?vue&type=script&lang=js&"
export * from "./TodoTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d88dea1c')) {
      api.createRecord('d88dea1c', component.options)
    } else {
      api.reload('d88dea1c', component.options)
    }
    module.hot.accept("./TodoTaskModal.vue?vue&type=template&id=d88dea1c&", function () {
      api.rerender('d88dea1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/eletronicSigned/modules/TodoTaskModal.vue"
export default component.exports